"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var ProductFeature = /*#__PURE__*/function () {
  function ProductFeature(component) {
    (0, _classCallCheck2["default"])(this, ProductFeature);
    this.dom = {
      $component: component,
      $scrollContainer: component.querySelector('.js-product-feature-scroll'),
      $scrollTrack: component.querySelector('.js-product-feature-track'),
      $scrollElement: component.querySelector('.js-product-feature-train')
    }, this.state = {
      inView: false,
      observer: false,
      observerConfig: {
        rootMargin: '100px 100px',
        threshold: 0
      },
      scrollPosition: 0,
      supportsIntersectionObserver: 'IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype
    };
    this.transformHandler = this.transformElement.bind(this);
    this.scrollHandler = this.checkScrollPosition.bind(this);
    this.mount();
    this.checkScrollPosition();
  }

  (0, _createClass2["default"])(ProductFeature, [{
    key: "mount",
    value: function mount() {
      var state = this.state;
      console.log('ProductFeature : mount', this);

      if (state.supportsIntersectionObserver) {
        this.observe();
        document.addEventListener('scroll', this.scrollHandler, true);
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      console.log('ProductFeature : unmount', this);

      if (state.supportsIntersectionObserver) {
        document.removeEventListener('scroll', this.scrollHandler, true);
      }
    }
  }, {
    key: "observe",
    value: function observe() {
      console.log('ProductFeature : observe', this);
      var state = this.state;
      state.observer = new IntersectionObserver(this.onIntersection.bind(this), state.observerConfig);
      [this.dom.$scrollContainer].forEach(function (element) {
        return state.observer.observe(element);
      });
    }
  }, {
    key: "onIntersection",
    value: function onIntersection(entries) {
      var dom = this.dom,
          state = this.state;
      console.log('ProductFeature : onIntersection', this, entries);
      var entry = entries[0];
      var inview = entry.intersectionRatio > 0;

      if (inview && !state.inView) {
        console.log('ProductFeature : onIntersection : translate', this, entries);
        state.inView = true;
      } else if (state.inView) {
        console.log('ProductFeature : onIntersection :  end translate', this, entries);
        state.inView = false;
      }
    }
  }, {
    key: "checkScrollPosition",
    value: function checkScrollPosition() {
      var dom = this.dom,
          state = this.state; // console.log('ProductFeature : checkScrollPosition', this);

      var lastScroll = state.scrollPosition;
      var currentScrollPosition = window.scrollY;

      if (state.inView) {
        var windowAspectRatio = window.innerHeight / window.innerWidth;
        var scrollPosition = window.scrollY + window.innerHeight;
        var startPosition = Math.round(dom.$scrollContainer.getBoundingClientRect().top + document.documentElement.scrollTop);
        var endPosition = Math.round(startPosition + window.innerHeight);
        var length = (endPosition - startPosition) / windowAspectRatio;
        var progress = Math.round((scrollPosition - startPosition) / length * 80) / windowAspectRatio;
        var clampedProgressValue = this.clampProgressValue(progress);
        state.transformValue = clampedProgressValue;
        window.requestAnimationFrame(this.transformHandler);
      }

      state.scrollPosition = currentScrollPosition;
    }
  }, {
    key: "clampProgressValue",
    value: function clampProgressValue(value) {
      return Math.min(Math.max(0, value), 100);
    }
  }, {
    key: "transformElement",
    value: function transformElement() {
      var dom = this.dom,
          state = this.state; // console.log('ProductFeature : transformElement', this);

      dom.$scrollElement.style.transform = "translateX(-".concat(state.transformValue, "%)");
    }
  }]);
  return ProductFeature;
}();

exports["default"] = ProductFeature;